import React from 'react'
import { ResponsiveLayout } from 'containers'
import { SettingsAndPreferencesWithRollout } from './SettingsAndPreferencesWithRollout'
import Header from 'containers/ResponsiveLayout/Header'

export const SettingsAndPreferencesMobileWrapper = () => {
  return (
    <ResponsiveLayout
      menu={<Header />}
      content={
        <div style={{ padding: '0 16px 8px' }}>
          <SettingsAndPreferencesWithRollout />
        </div>
      }
    />
  )
}
